
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import HomeIcon from '@mui/icons-material/Home';
import GitHubIcon from '@mui/icons-material/GitHub';
import ArticleIcon from '@mui/icons-material/Article';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'; 


const Menuitems = [
  {
    title: "Home",
    icon: HomeIcon,
    href: "/form-elements/home",
  },
  {
    title: "People",
    icon: PersonAddAlt1Icon,
    href: "/form-elements/people",
  },
  {
    title: "Articles",
    icon: ArticleIcon,
    href: "/form-elements/articles",
    children: [
      { title: "Nine Arts of software development", href: "/form-elements/articles/arts" },
      { title: "Visiting Professor",                href: "/form-elements/articles/professor" },
      { title: "Clean Code",                        href: "/form-elements/articles/code" },
      { title: "Clean Architecture",                href: "/form-elements/articles/architecture" },
      { title: "Transform Monolith 1",              href: "/form-elements/articles/monolith1" },
      { title: "Transform Monolith 2",              href: "/form-elements/articles/monolith2" },
      { title: "Solid Design",                      href: "/form-elements/articles/design" },
      { title: "C# Interview",                      href: "/form-elements/articles/interview" },
    ]
  },
  {
    title: "Technology",
    icon: GitHubIcon, 
    href: "/form-elements/technology",
    children: [
      { title: "Eco-system",                        href: "/form-elements/technology/eco" },
      { title: "Platform-Product Architecture",     href: "/form-elements/technology/architecture" },
      { title: "Server Asp.NET Core",               href: "/form-elements/technology/react" },
      { title: "Full-stack React",                  href: "/form-elements/technology/react" },
      { title: "Full-stack Angular",                href: "/form-elements/technology/angular" },
      { title: "Full-stack Blazor",                 href: "/form-elements/technology/blazor" },
      { title: "Desktop Presentation (WPF)",        href: "/form-elements/technology/desktop" },
    ]
  },
  {
    title: "Consulting",
    icon: MonetizationOnIcon, 
    href: "/form-elements/consulting",
    children: [
      { title: "Option Modeling",                   href: "/form-elements/consulting/option" },
      { title: "Project Management Dashboard",      href: "/form-elements/consulting/pmdash" },
      { title: "Medical Device Controller",         href: "/form-elements/consulting/medical" },
      { title: "Visiting Professor showcase",       href: "/form-elements/consulting/design" },
      { title: "Municipal Bond Management",         href: "/form-elements/consulting/munichain" },
      { title: "Donation Tracking Management",      href: "/form-elements/consulting/donation" },
    ]
  },
];

export default Menuitems;
